export default "__VITE_ASSET__66e50133__"